// extracted by mini-css-extract-plugin
export default {"btnDiv":"styles_btnDiv__9Tc3Z","outlinedBtnDiv":"styles_outlinedBtnDiv__OZ3cw"};